// extracted by mini-css-extract-plugin
export default {"page":"TX-z","cartModal":"UX-z","checkout":"VX-z","placeholder":"WX-z","account":"XX-z"};